<template>
  <div class="container _py-16 _px-md-4 _px-sm-0">
    <div class="other-head__container _mb-6 _px-sm-4">
      <slot name="title" />

      <div class="other-carousel__nav" v-if="showNav">
        <div @click="showPrev" class="other-carousel__nav-prev _mr-4">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="38" height="38" rx="16" fill="#D1D2CD" />
            <path
              d="M26 19H12M12 19L19 26M12 19L19 12"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div @click="showNext" class="other-carousel__nav-next">
          <svg
            width="38"
            height="38"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="38" height="38" rx="16" fill="#D1D2CD" />
            <path
              d="M12 19H26M26 19L19 12M26 19L19 26"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="other-carousel _ml-sm-4">
      <VueSlickCarousel v-bind="settings" ref="otherSlider">
        <OtherMaterials
          v-for="(item, ind) in items"
          :key="ind"
          :item="item"
          :analyticEventPrefix="analyticEventPrefix"
        ></OtherMaterials>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import OtherMaterials from '@/components/UI/OtherMaterials'

export default {
  name: 'OtherMain',
  components: {
    OtherMaterials,
    VueSlickCarousel,
  },
  props: {
    items: Array,
    analyticEventPrefix: String,
  },
  data: () => ({
    settings: {
      slidesToShow: 4,
      infinite: false,
      autoplay: false,
      arrows: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1220,
          settings: {
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            draggable: true,
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            infinite: false,
            variableWidth: true,
            draggable: true,
            arrows: false,
          },
        },
      ],
    },
  }),
  computed: {
    showNav() {
      return this.items.length > 4
    },
  },
  methods: {
    showNext() {
      this.$refs.otherSlider.next()
    },
    showPrev() {
      this.$refs.otherSlider.prev()
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.other-carousel {
  width: 100%;
  max-width: calc(100vw - 32px);
  &__nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media screen and (max-width: 1220px) {
      display: none;
    }
    &-prev,
    &-next {
      cursor: pointer;
      &:hover svg rect {
        fill: #7f7f7c;
      }
    }
    &-prev svg rect,
    &-next svg rect {
      transition: 0.2s linear;
    }
  }
}
.other-head__container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
</style>

<style lang="scss">
.slick-slide {
  padding: 0 16px;
}
.slick-slider {
  margin: 0 -16px;
  // width: 100%;
  @media screen and (max-width: 1220px) {
    width: calc(100vw + 32px);
  }
}
</style>
